import React, { useCallback, useMemo } from 'react';

import { Icon, Space, Tag, Typography } from '@sravni/react-design-system';
import { ArrowDown, Cross } from '@sravni/react-icons';
import { RegionDialog } from '@sravni/react-region-dialog';
import { useBoolean } from '@sravni/react-utils';
import { ILocationV2 } from '@sravni/types/lib/locations';

import { FILTER_NAMES, FILTERS } from '../../../../constants/reviews';
import { useAllLocations } from '../../../../store/hooks/locations';
import styles from '../../reviews-list-header.module.scss';

interface IProps {
  isMobile?: boolean;
  locationGarId?: FILTERS[FILTER_NAMES.LOCATION_GAR_ID];
  handleChange: (value, target) => void;
}

export const FilterRegion: React.FC<IProps> = ({ locationGarId, handleChange, isMobile }) => {
  const allLocations = useAllLocations();

  const [isVisibleRegionDialog, setVisibleRegionDialog] = useBoolean();

  const location = useMemo(() => {
    return allLocations.find(({ garId }) => garId === locationGarId);
  }, [allLocations, locationGarId]);

  const handleChangeLocation = useCallback(
    (value?: ILocationV2) => {
      handleChange(value?.garId, FILTER_NAMES.LOCATION_GAR_ID);
      setVisibleRegionDialog.off();
    },
    [handleChange, setVisibleRegionDialog],
  );

  const handleLocationClick = useCallback(() => {
    if (locationGarId) {
      // сбрасываем регион
      handleChangeLocation(null);
    } else {
      setVisibleRegionDialog.on();
    }
  }, [handleChangeLocation, locationGarId, setVisibleRegionDialog]);

  const onRegionDialogClose = useCallback(() => {
    setVisibleRegionDialog.off();
  }, [setVisibleRegionDialog]);

  const locationName = location?.name || 'Вся Россия';

  return (
    <>
      {isMobile ? (
        <Space direction={'vertical'} className={'h-mb-20'} onClick={setVisibleRegionDialog.on}>
          <Typography.Text size={16} strong className={'h-mb-8'}>
            Регион отзывов
          </Typography.Text>
          <div className={styles.textInput}>{locationName}</div>
        </Space>
      ) : (
        <Tag onClick={handleLocationClick} className={styles.dropdownButton}>
          {locationName} <Icon icon={location ? <Cross /> : <ArrowDown />} />
        </Tag>
      )}
      <RegionDialog
        title="Выберите город"
        visible={isVisibleRegionDialog}
        onChange={handleChangeLocation}
        onClose={onRegionDialogClose}
      />
    </>
  );
};
